module.exports = __webpack_public_path__ + "img/fpt_logo.e85dbccf.png";